/* stylelint-disable declaration-block-no-redundant-longhand-properties */
@import '../scss/tokens';

:host {
  display: block;
  background-color: #ffff;

  a {
    height: 100%;
    text-decoration: unset;
    color: unset;
  }

  .grid {
    height: 100%;
    white-space: normal;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: 100%;
    grid-template-areas: 'info image';
    text-align: left;
    overflow: hidden;

    &.portrait {
      grid-template-rows: minmax(0, 0.75fr) minmax(0, 1fr);
      grid-template-columns: 100%;
      grid-template-areas: 'image' 'info';
    }

    .info {
      grid-area: info;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: var(--sy-spacer-7);
      justify-content: flex-start;
      gap: 8px;
      box-sizing: border-box;
    }

    .flex-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      color: map-get($tokens, sy-blog-highlights-card-date-color);
      margin-top: auto;

      .author.skeleton {
        width: 32px;
        height: 32px;
        border-radius: 999px;
      }

      .update-date {
        --sy-text-small-font-size: 0.8rem;
        --sy-text-small-font-weight: 400;

        &.skeleton {
          width: 20%;
          height: 0.8rem;
        }
      }
    }

    .category {
      color: map-get($tokens, sy-blog-highlights-card-category-color);

      &.skeleton {
        width: 120px;
      }
    }

    .title {
      &.skeleton {
        width: 95%;
      }
    }

    .description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: map-get($tokens, sy-blog-highlights-card-line-clamp);
      color: map-get($tokens, sy-blog-highlights-card-description-color);
      overflow: hidden;
      text-overflow: ellipsis;

      &.skeleton {
        height: 125px;
        width: 100%;
      }
    }

    .image {
      grid-area: image;

      &.skeleton {
        height: 100%;
      }

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        overflow: hidden;
        border-radius: 0 var(--sy-border-radius) var(--sy-border-radius) 0;

        &.portrait {
          border-radius: var(--sy-border-radius) var(--sy-border-radius) 0 0;
        }
      }
    }
  }
}
